const LessThanIcon = /*#__PURE__*/ [
  ["path", { d: "M17 4L8.66943 10.0405C6.44352 11.6545 6.44353 12.3455 8.66943 13.9595L17 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { LessThanIcon as default };
//# sourceMappingURL=LessThanIcon.js.map
